module.exports = __webpack_public_path__ + "static/media/Together.73f62400.png";